import { useState, useEffect, useRef } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { ChevronDown, Search, Phone } from 'lucide-react';

// Comprehensive list of country codes
const COUNTRY_CODES = [
  { code: '+91', country: 'India', flag: '🇮🇳', iso: 'IN' },
  { code: '+1', country: 'United States', flag: '🇺🇸', iso: 'US' },
  { code: '+1', country: 'Canada', flag: '🇨🇦', iso: 'CA' },
  { code: '+44', country: 'United Kingdom', flag: '🇬🇧', iso: 'GB' },
  { code: '+61', country: 'Australia', flag: '🇦🇺', iso: 'AU' },
  { code: '+971', country: 'UAE', flag: '🇦🇪', iso: 'AE' },
  { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦', iso: 'SA' },
  { code: '+65', country: 'Singapore', flag: '🇸🇬', iso: 'SG' },
  { code: '+60', country: 'Malaysia', flag: '🇲🇾', iso: 'MY' },
  { code: '+49', country: 'Germany', flag: '🇩🇪', iso: 'DE' },
  { code: '+33', country: 'France', flag: '🇫🇷', iso: 'FR' },
  { code: '+39', country: 'Italy', flag: '🇮🇹', iso: 'IT' },
  { code: '+34', country: 'Spain', flag: '🇪🇸', iso: 'ES' },
  { code: '+31', country: 'Netherlands', flag: '🇳🇱', iso: 'NL' },
  { code: '+41', country: 'Switzerland', flag: '🇨🇭', iso: 'CH' },
  { code: '+46', country: 'Sweden', flag: '🇸🇪', iso: 'SE' },
  { code: '+47', country: 'Norway', flag: '🇳🇴', iso: 'NO' },
  { code: '+45', country: 'Denmark', flag: '🇩🇰', iso: 'DK' },
  { code: '+358', country: 'Finland', flag: '🇫🇮', iso: 'FI' },
  { code: '+43', country: 'Austria', flag: '🇦🇹', iso: 'AT' },
  { code: '+32', country: 'Belgium', flag: '🇧🇪', iso: 'BE' },
  { code: '+351', country: 'Portugal', flag: '🇵🇹', iso: 'PT' },
  { code: '+30', country: 'Greece', flag: '🇬🇷', iso: 'GR' },
  { code: '+48', country: 'Poland', flag: '🇵🇱', iso: 'PL' },
  { code: '+420', country: 'Czech Republic', flag: '🇨🇿', iso: 'CZ' },
  { code: '+36', country: 'Hungary', flag: '🇭🇺', iso: 'HU' },
  { code: '+7', country: 'Russia', flag: '🇷🇺', iso: 'RU' },
  { code: '+380', country: 'Ukraine', flag: '🇺🇦', iso: 'UA' },
  { code: '+90', country: 'Turkey', flag: '🇹🇷', iso: 'TR' },
  { code: '+972', country: 'Israel', flag: '🇮🇱', iso: 'IL' },
  { code: '+20', country: 'Egypt', flag: '🇪🇬', iso: 'EG' },
  { code: '+27', country: 'South Africa', flag: '🇿🇦', iso: 'ZA' },
  { code: '+234', country: 'Nigeria', flag: '🇳🇬', iso: 'NG' },
  { code: '+254', country: 'Kenya', flag: '🇰🇪', iso: 'KE' },
  { code: '+86', country: 'China', flag: '🇨🇳', iso: 'CN' },
  { code: '+81', country: 'Japan', flag: '🇯🇵', iso: 'JP' },
  { code: '+82', country: 'South Korea', flag: '🇰🇷', iso: 'KR' },
  { code: '+852', country: 'Hong Kong', flag: '🇭🇰', iso: 'HK' },
  { code: '+886', country: 'Taiwan', flag: '🇹🇼', iso: 'TW' },
  { code: '+66', country: 'Thailand', flag: '🇹🇭', iso: 'TH' },
  { code: '+84', country: 'Vietnam', flag: '🇻🇳', iso: 'VN' },
  { code: '+62', country: 'Indonesia', flag: '🇮🇩', iso: 'ID' },
  { code: '+63', country: 'Philippines', flag: '🇵🇭', iso: 'PH' },
  { code: '+92', country: 'Pakistan', flag: '🇵🇰', iso: 'PK' },
  { code: '+880', country: 'Bangladesh', flag: '🇧🇩', iso: 'BD' },
  { code: '+94', country: 'Sri Lanka', flag: '🇱🇰', iso: 'LK' },
  { code: '+977', country: 'Nepal', flag: '🇳🇵', iso: 'NP' },
  { code: '+95', country: 'Myanmar', flag: '🇲🇲', iso: 'MM' },
  { code: '+55', country: 'Brazil', flag: '🇧🇷', iso: 'BR' },
  { code: '+52', country: 'Mexico', flag: '🇲🇽', iso: 'MX' },
  { code: '+54', country: 'Argentina', flag: '🇦🇷', iso: 'AR' },
  { code: '+56', country: 'Chile', flag: '🇨🇱', iso: 'CL' },
  { code: '+57', country: 'Colombia', flag: '🇨🇴', iso: 'CO' },
  { code: '+51', country: 'Peru', flag: '🇵🇪', iso: 'PE' },
  { code: '+58', country: 'Venezuela', flag: '🇻🇪', iso: 'VE' },
  { code: '+64', country: 'New Zealand', flag: '🇳🇿', iso: 'NZ' },
  { code: '+353', country: 'Ireland', flag: '🇮🇪', iso: 'IE' },
  { code: '+974', country: 'Qatar', flag: '🇶🇦', iso: 'QA' },
  { code: '+973', country: 'Bahrain', flag: '🇧🇭', iso: 'BH' },
  { code: '+968', country: 'Oman', flag: '🇴🇲', iso: 'OM' },
  { code: '+965', country: 'Kuwait', flag: '🇰🇼', iso: 'KW' },
  { code: '+962', country: 'Jordan', flag: '🇯🇴', iso: 'JO' },
  { code: '+961', country: 'Lebanon', flag: '🇱🇧', iso: 'LB' },
  { code: '+98', country: 'Iran', flag: '🇮🇷', iso: 'IR' },
  { code: '+93', country: 'Afghanistan', flag: '🇦🇫', iso: 'AF' },
  { code: '+960', country: 'Maldives', flag: '🇲🇻', iso: 'MV' },
  { code: '+975', country: 'Bhutan', flag: '🇧🇹', iso: 'BT' },
];

// Parse phone number to extract country code and number
export const parsePhoneNumber = (fullNumber) => {
  if (!fullNumber) return { countryCode: '+91', number: '' };
  
  const cleanNumber = fullNumber.replace(/\s/g, '');
  
  // Try to match country codes (longest first)
  const sortedCodes = [...new Set(COUNTRY_CODES.map(c => c.code))].sort((a, b) => b.length - a.length);
  
  for (const code of sortedCodes) {
    if (cleanNumber.startsWith(code)) {
      return {
        countryCode: code,
        number: cleanNumber.slice(code.length)
      };
    }
  }
  
  // If no country code found, assume it's just the number
  if (cleanNumber.startsWith('+')) {
    // Unknown country code
    const match = cleanNumber.match(/^(\+\d{1,4})(.*)$/);
    if (match) {
      return { countryCode: match[1], number: match[2] };
    }
  }
  
  return { countryCode: '+91', number: cleanNumber };
};

// Format full phone number
export const formatPhoneNumber = (countryCode, number) => {
  if (!number) return '';
  return `${countryCode}${number}`;
};

export default function PhoneInput({ 
  value = '', 
  onChange, 
  placeholder = 'Phone number',
  disabled = false,
  required = false,
  className = '',
  'data-testid': dataTestId = 'phone-input'
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(COUNTRY_CODES[0]);
  const [phoneNumber, setPhoneNumber] = useState('');
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  // Parse initial value and when value changes
  useEffect(() => {
    if (value) {
      const { countryCode, number } = parsePhoneNumber(value);
      const country = COUNTRY_CODES.find(c => c.code === countryCode) || COUNTRY_CODES[0];
      setSelectedCountry(country);
      setPhoneNumber(number);
    } else {
      // Auto-detect country based on IP if no initial value
      setPhoneNumber('');
      detectCountryFromIP();
    }
  }, [value]);

  // Auto-detect country from IP
  const detectCountryFromIP = async () => {
    try {
      const response = await fetch('https://ipapi.co/json/', { 
        signal: AbortSignal.timeout(3000) // 3 second timeout
      });
      if (response.ok) {
        const data = await response.json();
        if (data.country_code) {
          const detected = COUNTRY_CODES.find(c => c.iso === data.country_code);
          if (detected) {
            setSelectedCountry(detected);
          }
        }
      }
    } catch (error) {
      // Silently fail - use default country
      console.log('Country detection failed, using default');
    }
  };

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearch('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Filter countries based on search
  const filteredCountries = COUNTRY_CODES.filter(country => 
    country.country.toLowerCase().includes(search.toLowerCase()) ||
    country.code.includes(search) ||
    country.iso.toLowerCase().includes(search.toLowerCase())
  );

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setIsOpen(false);
    setSearch('');
    // Notify parent of change
    if (onChange) {
      onChange(formatPhoneNumber(country.code, phoneNumber));
    }
    // Focus on phone input after selection
    inputRef.current?.focus();
  };

  const handlePhoneChange = (e) => {
    const newNumber = e.target.value.replace(/\D/g, '');
    setPhoneNumber(newNumber);
    if (onChange) {
      onChange(formatPhoneNumber(selectedCountry.code, newNumber));
    }
  };

  return (
    <div className={`relative flex ${className}`} ref={dropdownRef}>
      {/* Country Code Selector */}
      <Button
        type="button"
        variant="outline"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
        className="rounded-r-none border-r-0 px-2 min-w-[90px] justify-between"
        data-testid={`${dataTestId}-country`}
      >
        <span className="flex items-center gap-1">
          <span className="text-base">{selectedCountry.flag}</span>
          <span className="text-sm font-medium">{selectedCountry.code}</span>
        </span>
        <ChevronDown className="h-3 w-3 ml-1 opacity-50" />
      </Button>

      {/* Phone Number Input */}
      <Input
        ref={inputRef}
        type="tel"
        value={phoneNumber}
        onChange={handlePhoneChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        className="rounded-l-none flex-1"
        data-testid={`${dataTestId}-number`}
      />

      {/* Dropdown */}
      {isOpen && (
        <div className="absolute top-full left-0 mt-1 w-72 bg-white border rounded-lg shadow-lg z-50">
          {/* Search */}
          <div className="p-2 border-b">
            <div className="relative">
              <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
              <Input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search country or code..."
                className="pl-8 h-9"
                autoFocus
              />
            </div>
          </div>
          
          {/* Country List */}
          <ScrollArea className="h-64">
            <div className="p-1">
              {filteredCountries.length === 0 ? (
                <div className="text-center py-4 text-sm text-muted-foreground">
                  No countries found
                </div>
              ) : (
                filteredCountries.map((country, index) => (
                  <button
                    key={`${country.iso}-${index}`}
                    type="button"
                    onClick={() => handleCountrySelect(country)}
                    className={`w-full flex items-center gap-3 px-3 py-2 rounded-md text-left hover:bg-gray-100 transition-colors ${
                      selectedCountry.iso === country.iso && selectedCountry.code === country.code 
                        ? 'bg-indigo-50 text-indigo-700' 
                        : ''
                    }`}
                  >
                    <span className="text-xl">{country.flag}</span>
                    <span className="flex-1 text-sm">{country.country}</span>
                    <span className="text-sm text-muted-foreground font-mono">{country.code}</span>
                  </button>
                ))
              )}
            </div>
          </ScrollArea>
        </div>
      )}
    </div>
  );
}

// Simple display component for showing formatted phone
export function PhoneDisplay({ value, className = '' }) {
  if (!value) return <span className="text-muted-foreground">-</span>;
  
  const { countryCode, number } = parsePhoneNumber(value);
  const country = COUNTRY_CODES.find(c => c.code === countryCode);
  
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      {country && <span>{country.flag}</span>}
      <span>{countryCode} {number}</span>
    </span>
  );
}

export { COUNTRY_CODES };
